"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7530],{

/***/ 52030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Draggable; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 3 modules
var ConfigProvider = __webpack_require__(40360);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/Draggable/item.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


function Item(props) {
    var _a;
    var prefixCls = props.prefixCls, style = props.style, children = props.children, direction = props.direction, disabled = props.disabled, _b = props.droppable, droppable = _b === void 0 ? true : _b, onDrop = props.onDrop, onDragStart = props.onDragStart, onDragEnd = props.onDragEnd, onDragOver = props.onDragOver, onDragLeave = props.onDragLeave;
    var refItem = (0,react.useRef)(null);
    var refDraggedTimer = (0,react.useRef)(null);
    var _c = __read((0,react.useState)('none'), 2), dragStatus = _c[0], setDragStatus = _c[1];
    var _d = __read((0,react.useState)(false), 2), dragOver = _d[0], setDragOver = _d[1];
    var _e = __read((0,react.useState)(null), 2), dragPosition = _e[0], setDragPosition = _e[1];
    (0,react.useEffect)(function () {
        return function () {
            refDraggedTimer.current && clearTimeout(refDraggedTimer.current);
        };
    }, []);
    (0,react.useEffect)(function () {
        if (dragStatus === 'dragged') {
            refDraggedTimer.current = setTimeout(function () { return setDragStatus('none'); }, 1000);
        }
    }, [dragStatus]);
    return (react.createElement("li", { draggable: true, ref: refItem, style: style, className: (0,classNames/* default */.Z)(prefixCls + "-item", (_a = {},
            _a[prefixCls + "-item-" + dragStatus] = dragStatus !== 'none',
            _a[prefixCls + "-item-gap-" + dragPosition] = dragPosition,
            _a[prefixCls + "-item-disabled"] = disabled,
            _a[prefixCls + "-item-dragover"] = dragOver,
            _a)), onDragStart: function (event) {
            event.stopPropagation();
            setDragStatus('dragging');
            try {
                // ie throw error
                // firefox-need-it
                event.dataTransfer.setData('text/plain', '');
            }
            catch (error) { }
            onDragStart && onDragStart(event);
        }, onDragEnd: function (event) {
            event.stopPropagation();
            setDragOver(false);
            setDragStatus('dragged');
            onDragEnd && onDragEnd(event);
        }, onDragOver: function (event) {
            if (droppable) {
                event.stopPropagation();
                event.preventDefault();
                var rect = refItem.current.getBoundingClientRect();
                if (direction === 'vertical') {
                    setDragPosition(event.pageY > window.pageYOffset + rect.top + rect.height / 2 ? 'bottom' : 'top');
                }
                else {
                    setDragPosition(event.pageX > window.pageXOffset + rect.left + rect.width / 2 ? 'right' : 'left');
                }
                setDragOver(true);
                onDragOver && onDragOver(event);
            }
        }, onDragLeave: function (event) {
            if (droppable) {
                event.stopPropagation();
                setDragOver(false);
                onDragLeave && onDragLeave(event);
            }
        }, onDrop: function (event) {
            if (droppable) {
                event.stopPropagation();
                event.preventDefault();
                setDragOver(false);
                setDragPosition(null);
                setDragStatus('none');
                onDrop && onDrop(event, dragPosition);
            }
        } }, children));
}
/* harmony default export */ var item = (Item);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/Draggable/index.js
var Draggable_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




function Draggable(props) {
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('draggable');
    var className = props.className, children = props.children, _a = props.direction, direction = _a === void 0 ? 'vertical' : _a, onIndexChange = props.onIndexChange, itemWrapperStyle = props.itemWrapperStyle;
    var _b = Draggable_read((0,react.useState)(null), 2), dragItemIndex = _b[0], setDragItemIndex = _b[1];
    return (react.createElement("div", { className: (0,classNames/* default */.Z)(prefixCls, className) }, react.Children.map(children, function (child, index) {
        return (react.createElement(item, { style: itemWrapperStyle, prefixCls: prefixCls, direction: direction, onDragStart: function () { return setDragItemIndex(index); }, onDragEnd: function () { return setDragItemIndex(null); }, onDrop: function (_, dropPosition) {
                var prevIndex = dragItemIndex;
                var nextIndex = dropPosition === 'left' || dropPosition === 'top' ? index : index + 1;
                if (onIndexChange && prevIndex !== nextIndex) {
                    onIndexChange(nextIndex, prevIndex);
                }
            } }, child));
    })));
}


/***/ }),

/***/ 20179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _class_VirtualList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/getStringLength.js
// 计算字符串长度，中文字符占两个长度
/* harmony default export */ function getStringLength(str) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
            len += 2;
        }
        else {
            len++;
        }
    }
    return len;
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/VirtualList/utils/itemUtil.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * 为了计算方便，定位元素的下标可能返回数组长度，代表最后一个元素
 */
var GHOST_ITEM_KEY = '__rc_ghost_item__';
/**
 * 根据滚动条当前的滚动百分比，计算出基准元素
 * 在基准元素的上方和下方渲染可见区域的其他元素
 */
function getLocationItem(scrollPtg, total) {
    var itemIndex = Math.floor(scrollPtg * total);
    var itemTopPtg = itemIndex / total;
    var offsetPtg = (scrollPtg - itemTopPtg) / (1 / total);
    return {
        index: itemIndex,
        // scrollPtg >= itemTopPtg，计算结果为元素应当补充的滚动距离相对自身高度的偏移量
        offsetPtg: Number.isNaN(offsetPtg) ? 0 : offsetPtg,
    };
}
/**
 * 获取HTML元素高度
 */
function getNodeHeight(node, needMargin) {
    if (needMargin === void 0) { needMargin = false; }
    var element = (0,react_dom.findDOMNode)(node);
    var marginVertical = 0;
    if (needMargin) {
        var _a = window.getComputedStyle(node), marginTop = _a.marginTop, marginBottom = _a.marginBottom;
        marginVertical = Number(marginTop.replace(/\D/g, '')) + Number(marginBottom.replace(/\D/g, ''));
        marginVertical = isNaN(marginVertical) ? 0 : marginVertical;
    }
    return element ? element.offsetHeight + marginVertical : 0;
}
/**
 * 获取有效的scrollTop值
 * Safari的缓动效果会获得负值的scrollTop
 */
function getValidScrollTop(scrollTop, scrollRange) {
    return scrollTop < 0 ? 0 : scrollTop > scrollRange ? scrollRange : scrollTop;
}
/**
 * 视口已滚动距离 / 总可滚动距离
 */
function getScrollPercentage(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    var scrollRange = scrollHeight - clientHeight;
    return scrollRange <= 0 ? 0 : getValidScrollTop(scrollTop, scrollRange) / scrollRange;
}
/**
 * 计算需要渲染的元素的开始下标、结束下标和用于定位的元素下标
 */
function getRangeIndex(scrollPtg, itemCount, visibleCount) {
    var _a = getLocationItem(scrollPtg, itemCount), index = _a.index, offsetPtg = _a.offsetPtg;
    var beforeCount = Math.ceil(scrollPtg * visibleCount);
    var afterCount = Math.ceil((1 - scrollPtg) * visibleCount);
    return {
        itemIndex: index,
        itemOffsetPtg: offsetPtg,
        startIndex: Math.max(0, index - beforeCount),
        endIndex: Math.min(itemCount - 1, index + afterCount),
    };
}
/**
 * 计算元素相对于视口顶部的偏移量
 */
function getItemRelativeTop(_a) {
    var itemHeight = _a.itemHeight, itemOffsetPtg = _a.itemOffsetPtg, scrollPtg = _a.scrollPtg, clientHeight = _a.clientHeight;
    return Math.floor(clientHeight * scrollPtg - itemHeight * itemOffsetPtg);
}
/**
 * 计算元素相对于整个滚动区域顶部的偏移量
 */
function getItemAbsoluteTop(_a) {
    var scrollTop = _a.scrollTop, rest = __rest(_a, ["scrollTop"]);
    return scrollTop + getItemRelativeTop(rest);
}
/**
 * 计算某一指定下标的元素相对于视口顶部的偏移量
 */
function getCompareItemRelativeTop(_a) {
    var locatedItemRelativeTop = _a.locatedItemRelativeTop, locatedItemIndex = _a.locatedItemIndex, compareItemIndex = _a.compareItemIndex, startIndex = _a.startIndex, endIndex = _a.endIndex, getItemKey = _a.getItemKey, itemElementHeights = _a.itemElementHeights, itemHeight = _a.itemHeight;
    var compareItemTop = locatedItemRelativeTop;
    var compareItemKey = getItemKey(compareItemIndex);
    if (compareItemIndex <= locatedItemIndex) {
        for (var index = locatedItemIndex; index >= startIndex; index -= 1) {
            var key = getItemKey(index);
            if (key === compareItemKey) {
                break;
            }
            var prevItemKey = getItemKey(index - 1);
            compareItemTop -= itemElementHeights[prevItemKey] || itemHeight;
        }
    }
    else {
        for (var index = locatedItemIndex; index <= endIndex; index += 1) {
            var key = getItemKey(index);
            if (key === compareItemKey) {
                break;
            }
            compareItemTop += itemElementHeights[key] || itemHeight;
        }
    }
    return compareItemTop;
}
function getLongestItemIndex(data) {
    var result = -1;
    var length = 0;
    data.forEach(function (item, index) {
        var _a;
        item = typeof item === 'string' ? item : (_a = item.props) === null || _a === void 0 ? void 0 : _a.children;
        if (typeof item === 'string') {
            var _length = getStringLength(item);
            if (_length > length) {
                length = _length;
                result = index;
            }
        }
    });
    return result;
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/raf.js
var raf = __webpack_require__(44734);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/usePrevious.js
var usePrevious = __webpack_require__(69882);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/VirtualList/utils/algorithmUtil.js
// https://github.com/react-component/virtual-list/blob/master/src/utils/algorithmUtil.ts
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */
function getIndexByStartLoc(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) {
            return start + stepIndex + 1;
        }
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) {
        return start - (index - afterCount);
    }
    return start + (index - beforeCount);
}
/**
 * We assume that 2 list has only 1 item diff and others keeping the order.
 * So we can use dichotomy algorithm to find changed one.
 */
function findListDiffIndex(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) {
        return null;
    }
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    }
    else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = { __EMPTY_ITEM__: true };
    function getItemKey(item, index) {
        return item !== undefined ? getKey(item, index) : notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for (var i = 0; i < longList.length; i += 1) {
        var shortKey = getItemKey(shortList[i], i);
        var longKey = getItemKey(longList[i], i);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1], i + 1);
            break;
        }
    }
    return diffIndex === null ? null : { index: diffIndex, multiple: multiple };
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/VirtualList/Filler.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * Create visual height for content
 */
var Filler = function (_a) {
    var height = _a.height, offset = _a.offset, children = _a.children, propsOuterStyle = _a.outerStyle, propsInnerStyle = _a.innerStyle;
    var outerStyle = {};
    var innerStyle = {
        display: 'flex',
        flexDirection: 'column',
    };
    if (offset !== undefined) {
        outerStyle = __assign({ height: height, position: 'relative', overflow: 'hidden', zIndex: 0 }, propsOuterStyle);
        innerStyle = __assign(__assign(__assign({}, innerStyle), { transform: "translateY(" + offset + "px)", position: 'absolute', left: 0, right: 0, top: 0 }), propsInnerStyle);
    }
    return (react.createElement("div", { style: outerStyle },
        react.createElement("div", { style: innerStyle }, children)));
};
/* harmony default export */ var VirtualList_Filler = (Filler);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useStateWithPromise.js
var useStateWithPromise = __webpack_require__(23259);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsFirstRender.js
var useIsFirstRender = __webpack_require__(91626);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useForceUpdate.js
var useForceUpdate = __webpack_require__(65166);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/resizeObserver.js
var resizeObserver = __webpack_require__(68761);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(81109);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/VirtualList/index.js
var VirtualList_assign = (undefined && undefined.__assign) || function () {
    VirtualList_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return VirtualList_assign.apply(this, arguments);
};
var VirtualList_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












// height of the virtual element, used to calculate total height of the virtual list
var DEFAULT_VIRTUAL_ITEM_HEIGHT = 32;
var KEY_VIRTUAL_ITEM_HEIGHT = "__virtual_item_height_" + Math.random().toFixed(5).slice(2);
// after collecting the real height of the first screen element, calculate the virtual ItemHeight to trigger list re-rendering
var useComputeVirtualItemHeight = function (refItemHeightMap) {
    var forceUpdate = (0,useForceUpdate/* default */.Z)();
    var heightMap = refItemHeightMap.current;
    (0,react.useEffect)(function () {
        // virtual item height should be static as possible, otherwise it is easy to cause jitter
        if (Object.keys(heightMap).length && !heightMap[KEY_VIRTUAL_ITEM_HEIGHT]) {
            heightMap[KEY_VIRTUAL_ITEM_HEIGHT] = Object.entries(heightMap).reduce(function (sum, _a, currentIndex, array) {
                var _b = __read(_a, 2), currentHeight = _b[1];
                var nextSum = sum + currentHeight;
                return currentIndex === array.length - 1 ? Math.round(nextSum / array.length) : nextSum;
            }, 0);
            forceUpdate();
        }
    }, [Object.keys(heightMap).length]);
};
// cache the constructed results of child nodes to avoid redrawing of child nodes caused by re-construction during drawing
var useCacheChildrenNodes = function (children) {
    var refCacheMap = (0,react.useRef)({});
    var refPrevChildren = (0,react.useRef)(children);
    (0,react.useEffect)(function () {
        refPrevChildren.current = children;
    }, [children]);
    // children change means state of parent component is updated, so clear cache
    if (children !== refPrevChildren.current) {
        refCacheMap.current = {};
    }
    return function (item, index, props) {
        if (!refCacheMap.current.hasOwnProperty(index)) {
            refCacheMap.current[index] = children(item, index, props);
        }
        return refCacheMap.current[index];
    };
};
var VirtualList = react.forwardRef(function (props, ref) {
    var style = props.style, className = props.className, children = props.children, _a = props.data, data = _a === void 0 ? [] : _a, itemKey = props.itemKey, _b = props.threshold, threshold = _b === void 0 ? 100 : _b, _c = props.wrapper, WrapperTagName = _c === void 0 ? 'div' : _c, _d = props.height, propHeight = _d === void 0 ? '100%' : _d, _e = props.isStaticItemHeight, isStaticItemHeight = _e === void 0 ? true : _e, propItemHeight = props.itemHeight, measureLongestItem = props.measureLongestItem, scrollOptions = props.scrollOptions, onScroll = props.onScroll, _f = props.needFiller, needFiller = _f === void 0 ? true : _f, outerStyle = props.outerStyle, innerStyle = props.innerStyle, restProps = VirtualList_rest(props, ["style", "className", "children", "data", "itemKey", "threshold", "wrapper", "height", "isStaticItemHeight", "itemHeight", "measureLongestItem", "scrollOptions", "onScroll", "needFiller", "outerStyle", "innerStyle"]);
    // Compatible with setting the height of the list through style.maxHeight
    var styleListMaxHeight = (style && style.maxHeight) || propHeight;
    var refItemHeightMap = (0,react.useRef)({});
    var _g = __read((0,react.useState)(200), 2), stateHeight = _g[0], setStateHeight = _g[1];
    var renderChild = useCacheChildrenNodes(children);
    useComputeVirtualItemHeight(refItemHeightMap);
    // Elements with the same height, the height of the item is based on the first rendering
    var itemCount = data.length;
    var itemHeight = propItemHeight ||
        refItemHeightMap.current[KEY_VIRTUAL_ITEM_HEIGHT] ||
        DEFAULT_VIRTUAL_ITEM_HEIGHT;
    var viewportHeight = (0,is/* isNumber */.hj)(styleListMaxHeight) ? styleListMaxHeight : stateHeight;
    var itemCountVisible = Math.ceil(viewportHeight / itemHeight);
    var itemTotalHeight = itemHeight * itemCount;
    var isVirtual = threshold !== null && itemCount >= threshold && itemTotalHeight > viewportHeight;
    var refList = (0,react.useRef)(null);
    var refRafId = (0,react.useRef)(null);
    var refLockScroll = (0,react.useRef)(false);
    var refIsVirtual = (0,react.useRef)(isVirtual);
    // The paddingTop of the record scrolling list is used to correct the scrolling distance
    var scrollListPadding = (0,react.useMemo)(function () {
        if (refList.current) {
            var getPadding = function (property) {
                return +window.getComputedStyle(refList.current)[property].replace(/\D/g, '');
            };
            return {
                top: getPadding('paddingTop'),
                bottom: getPadding('paddingBottom'),
            };
        }
        return { top: 0, bottom: 0 };
    }, [refList.current]);
    var _h = __read((0,useStateWithPromise/* default */.Z)({
        // measure status
        status: 'NONE',
        // render range info
        startIndex: 0,
        endIndex: 0,
        itemIndex: 0,
        itemOffsetPtg: 0,
        // scroll info
        startItemTop: 0,
        scrollTop: 0,
    }), 2), state = _h[0], setState = _h[1];
    var prevData = (0,usePrevious/* default */.Z)(data) || [];
    var isFirstRender = (0,useIsFirstRender/* default */.Z)();
    var getItemKey = function (item, index) {
        return typeof itemKey === 'function'
            ? itemKey(item, index)
            : typeof itemKey === 'string'
                ? item[itemKey]
                : item.key || index;
    };
    var getItemKeyByIndex = function (index, items) {
        if (items === void 0) { items = data; }
        if (index === items.length) {
            return GHOST_ITEM_KEY;
        }
        var item = items[index];
        return item !== undefined ? getItemKey(item, index) : null;
    };
    var getCachedItemHeight = function (key) {
        return refItemHeightMap.current[key] || itemHeight;
    };
    var internalScrollTo = function (relativeScroll) {
        var compareItemIndex = relativeScroll.itemIndex, compareItemRelativeTop = relativeScroll.relativeTop;
        var _a = refList.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        var originScrollTop = state.scrollTop;
        var maxScrollTop = scrollHeight - clientHeight;
        var bestSimilarity = Number.MAX_VALUE;
        var bestScrollTop = null;
        var bestItemIndex = null;
        var bestItemOffsetPtg = null;
        var bestStartIndex = null;
        var bestEndIndex = null;
        var missSimilarity = 0;
        for (var i = 0; i < maxScrollTop; i++) {
            var scrollTop = getIndexByStartLoc(0, maxScrollTop, originScrollTop, i);
            var scrollPtg = getScrollPercentage({ scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight });
            var _b = getRangeIndex(scrollPtg, itemCount, itemCountVisible), itemIndex = _b.itemIndex, itemOffsetPtg = _b.itemOffsetPtg, startIndex = _b.startIndex, endIndex = _b.endIndex;
            if (startIndex <= compareItemIndex && compareItemIndex <= endIndex) {
                var locatedItemRelativeTop = getItemRelativeTop({
                    itemHeight: getCachedItemHeight(getItemKeyByIndex(itemIndex)),
                    itemOffsetPtg: itemOffsetPtg,
                    clientHeight: clientHeight,
                    scrollPtg: scrollPtg,
                });
                var compareItemTop = getCompareItemRelativeTop({
                    locatedItemRelativeTop: locatedItemRelativeTop,
                    locatedItemIndex: itemIndex,
                    compareItemIndex: compareItemIndex,
                    startIndex: startIndex,
                    endIndex: endIndex,
                    itemHeight: itemHeight,
                    getItemKey: getItemKeyByIndex,
                    itemElementHeights: refItemHeightMap.current,
                });
                var similarity = Math.abs(compareItemTop - compareItemRelativeTop);
                if (similarity < bestSimilarity) {
                    bestSimilarity = similarity;
                    bestScrollTop = scrollTop;
                    bestItemIndex = itemIndex;
                    bestItemOffsetPtg = itemOffsetPtg;
                    bestStartIndex = startIndex;
                    bestEndIndex = endIndex;
                    missSimilarity = 0;
                }
                else {
                    missSimilarity += 1;
                }
            }
            if (missSimilarity > 10) {
                break;
            }
        }
        if (bestScrollTop !== null) {
            refLockScroll.current = true;
            refList.current.scrollTop = bestScrollTop;
            setState(VirtualList_assign(VirtualList_assign({}, state), { status: 'MEASURE_START', scrollTop: bestScrollTop, itemIndex: bestItemIndex, itemOffsetPtg: bestItemOffsetPtg, startIndex: bestStartIndex, endIndex: bestEndIndex }));
        }
        refRafId.current = (0,raf/* raf */.W)(function () {
            refLockScroll.current = false;
        });
    };
    // Record the current element position when the real list is scrolled, and ensure that the position is correct after switching to the virtual list
    var rawListScrollHandler = function (event) {
        var _a = refList.current, rawScrollTop = _a.scrollTop, clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
        var scrollTop = getValidScrollTop(rawScrollTop, scrollHeight - clientHeight);
        var scrollPtg = getScrollPercentage({
            scrollTop: scrollTop,
            clientHeight: clientHeight,
            scrollHeight: scrollHeight,
        });
        var _b = getLocationItem(scrollPtg, itemCount), index = _b.index, offsetPtg = _b.offsetPtg;
        setState(VirtualList_assign(VirtualList_assign({}, state), { scrollTop: scrollTop, itemIndex: index, itemOffsetPtg: offsetPtg }));
        event && onScroll && onScroll(event);
    };
    // Modify the state and recalculate the position in the next render
    var virtualListScrollHandler = function (event, isInit) {
        if (isInit === void 0) { isInit = false; }
        // Do NOT use refList.current.scrollHeight
        // We should use Filler's height as total scroll height
        // Filler's translate style may make refList.current.scrollHeight larger than Filler's height
        var scrollHeight = itemTotalHeight;
        var _a = refList.current, rawScrollTop = _a.scrollTop, clientHeight = _a.clientHeight;
        var scrollTop = getValidScrollTop(rawScrollTop, scrollHeight - clientHeight);
        // Prevent jitter
        if (!isInit && (scrollTop === state.scrollTop || refLockScroll.current)) {
            return;
        }
        var scrollPtg = getScrollPercentage({
            scrollTop: scrollTop,
            clientHeight: clientHeight,
            scrollHeight: scrollHeight,
        });
        var _b = getRangeIndex(scrollPtg, itemCount, itemCountVisible), itemIndex = _b.itemIndex, itemOffsetPtg = _b.itemOffsetPtg, startIndex = _b.startIndex, endIndex = _b.endIndex;
        setState(VirtualList_assign(VirtualList_assign({}, state), { scrollTop: scrollTop, itemIndex: itemIndex, itemOffsetPtg: itemOffsetPtg, startIndex: startIndex, endIndex: endIndex, status: 'MEASURE_START' }));
        event && onScroll && onScroll(event);
    };
    (0,react.useEffect)(function () {
        return function () {
            refRafId.current && (0,raf/* caf */.N)(refRafId.current);
        };
    }, []);
    // rerender when the number of visible elements changes
    (0,react.useEffect)(function () {
        if (refList.current) {
            if (isFirstRender) {
                refList.current.scrollTop = 0;
            }
            virtualListScrollHandler(null, true);
        }
    }, [itemCountVisible]);
    // Handle additions and deletions of list items or switching the virtual state
    (0,react.useEffect)(function () {
        if (!refList.current)
            return;
        var changedItemIndex = null;
        var switchTo = refIsVirtual.current !== isVirtual ? (isVirtual ? 'virtual' : 'raw') : '';
        refIsVirtual.current = isVirtual;
        if (viewportHeight && prevData.length !== data.length) {
            var diff = findListDiffIndex(prevData, data, getItemKey);
            changedItemIndex = diff ? diff.index : null;
        }
        // No need to correct the position when the number of elements in the real list changes
        if (switchTo || (isVirtual && changedItemIndex)) {
            var clientHeight = refList.current.clientHeight;
            var locatedItemRelativeTop = getItemRelativeTop({
                itemHeight: getCachedItemHeight(getItemKeyByIndex(state.itemIndex, prevData)),
                itemOffsetPtg: state.itemOffsetPtg,
                scrollPtg: getScrollPercentage({
                    scrollTop: state.scrollTop,
                    scrollHeight: prevData.length * itemHeight,
                    clientHeight: clientHeight,
                }),
                clientHeight: clientHeight,
            });
            if (switchTo === 'raw') {
                var rawTop = locatedItemRelativeTop;
                for (var index = 0; index < state.itemIndex; index++) {
                    rawTop -= getCachedItemHeight(getItemKeyByIndex(index));
                }
                refList.current.scrollTop = -rawTop;
                refLockScroll.current = true;
                refRafId.current = (0,raf/* raf */.W)(function () {
                    refLockScroll.current = false;
                });
            }
            else {
                internalScrollTo({
                    itemIndex: state.itemIndex,
                    relativeTop: locatedItemRelativeTop,
                });
            }
        }
    }, [data, isVirtual]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        if (state.status === 'MEASURE_START' && refList.current) {
            var _a = refList.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            var scrollPtg = getScrollPercentage({
                scrollTop: scrollTop,
                scrollHeight: scrollHeight,
                clientHeight: clientHeight,
            });
            // Calculate the top value of the first rendering element
            var startItemTop = getItemAbsoluteTop({
                scrollPtg: scrollPtg,
                clientHeight: clientHeight,
                scrollTop: scrollTop - (scrollListPadding.top + scrollListPadding.bottom) * scrollPtg,
                itemHeight: getCachedItemHeight(getItemKeyByIndex(state.itemIndex)),
                itemOffsetPtg: state.itemOffsetPtg,
            });
            for (var index = state.itemIndex - 1; index >= state.startIndex; index--) {
                startItemTop -= getCachedItemHeight(getItemKeyByIndex(index));
            }
            setState(VirtualList_assign(VirtualList_assign({}, state), { startItemTop: startItemTop, status: 'MEASURE_DONE' }));
        }
    }, [state]);
    (0,react.useImperativeHandle)(ref, function () { return ({
        dom: refList.current,
        // Scroll to a certain height or an element
        scrollTo: function (arg) {
            refRafId.current && (0,raf/* caf */.N)(refRafId.current);
            refRafId.current = (0,raf/* raf */.W)(function () {
                var _a;
                if (!refList.current)
                    return;
                if (typeof arg === 'number') {
                    refList.current.scrollTop = arg;
                    return;
                }
                var index = 'index' in arg
                    ? arg.index
                    : 'key' in arg
                        ? data.findIndex(function (item, index) { return getItemKey(item, index) === arg.key; })
                        : 0;
                var item = data[index];
                if (!item) {
                    return;
                }
                var align = typeof arg === 'object' && ((_a = arg.options) === null || _a === void 0 ? void 0 : _a.block)
                    ? arg.options.block
                    : (scrollOptions === null || scrollOptions === void 0 ? void 0 : scrollOptions.block) || 'nearest';
                var _b = refList.current, clientHeight = _b.clientHeight, scrollTop = _b.scrollTop;
                if (isVirtual && !isStaticItemHeight) {
                    if (align === 'nearest') {
                        var itemIndex = state.itemIndex, itemOffsetPtg = state.itemOffsetPtg;
                        if (Math.abs(itemIndex - index) < itemCountVisible) {
                            var itemTop = getItemRelativeTop({
                                itemHeight: getCachedItemHeight(getItemKeyByIndex(itemIndex)),
                                itemOffsetPtg: itemOffsetPtg,
                                clientHeight: clientHeight,
                                scrollPtg: getScrollPercentage(refList.current),
                            });
                            if (index < itemIndex) {
                                for (var i = index; i < itemIndex; i++) {
                                    itemTop -= getCachedItemHeight(getItemKeyByIndex(i));
                                }
                            }
                            else {
                                for (var i = itemIndex; i < index; i++) {
                                    itemTop += getCachedItemHeight(getItemKeyByIndex(i));
                                }
                            }
                            // When the target element is within the field of view, exit directly
                            if (itemTop < 0 || itemTop > clientHeight) {
                                align = itemTop < 0 ? 'start' : 'end';
                            }
                            else {
                                return;
                            }
                        }
                        else {
                            align = index < itemIndex ? 'start' : 'end';
                        }
                    }
                    setState(VirtualList_assign(VirtualList_assign({}, state), { startIndex: Math.max(0, index - itemCountVisible), endIndex: Math.min(itemCount - 1, index + itemCountVisible) })).then(function () {
                        var itemHeight = getCachedItemHeight(getItemKey(item, index));
                        internalScrollTo({
                            itemIndex: index,
                            relativeTop: align === 'start'
                                ? 0
                                : (clientHeight - itemHeight) / (align === 'center' ? 2 : 1),
                        });
                    });
                }
                else {
                    var indexItemHeight = getCachedItemHeight(getItemKeyByIndex(index));
                    var itemTop = 0;
                    for (var i = 0; i < index; i++) {
                        itemTop += getCachedItemHeight(getItemKeyByIndex(i));
                    }
                    var itemBottom = itemTop + indexItemHeight;
                    var itemMiddle = itemTop + indexItemHeight / 2;
                    // If item is visible, skip scrolling
                    if (itemMiddle > scrollTop && itemMiddle < clientHeight + scrollTop) {
                        return;
                    }
                    if (align === 'nearest') {
                        if (itemTop < scrollTop) {
                            align = 'start';
                        }
                        else if (itemBottom > scrollTop + clientHeight) {
                            align = 'end';
                        }
                    }
                    var viewportHeight_1 = clientHeight - indexItemHeight;
                    refList.current.scrollTop =
                        itemTop - (align === 'start' ? 0 : viewportHeight_1 / (align === 'center' ? 2 : 1));
                }
            });
        },
    }); }, [data, itemHeight, state]);
    var renderChildren = function (list, startIndex) {
        return list.map(function (item, index) {
            var originIndex = startIndex + index;
            var node = renderChild(item, originIndex, {
                style: {},
                itemIndex: index,
            });
            var key = getItemKey(item, originIndex);
            return react.cloneElement(node, {
                key: key,
                ref: function (ele) {
                    var heightMap = refItemHeightMap.current;
                    // Minimize the measurement of element height as much as possible to avoid frequent triggering of browser reflow
                    // Method getNodeHeight get the clientHeight from the DOM referred by React ref. If result is wrong, check the ref of this element
                    if (ele &&
                        state.status === 'MEASURE_START' &&
                        (!isStaticItemHeight || heightMap[key] === undefined)) {
                        if (isStaticItemHeight) {
                            if (!heightMap[KEY_VIRTUAL_ITEM_HEIGHT]) {
                                heightMap[KEY_VIRTUAL_ITEM_HEIGHT] = getNodeHeight(ele, true);
                            }
                            heightMap[key] = heightMap[KEY_VIRTUAL_ITEM_HEIGHT];
                        }
                        else {
                            heightMap[key] = getNodeHeight(ele, true);
                        }
                    }
                },
            });
        });
    };
    // Render the widest element to provide the maximum width of the container initially
    var refLongestItemIndex = (0,react.useRef)(null);
    // Don't add `renderChild` to the array dependency, it will change every time when rerender
    (0,react.useEffect)(function () {
        refLongestItemIndex.current = null;
    }, [data]);
    var renderLongestItem = function () {
        if (measureLongestItem) {
            var index = refLongestItemIndex.current === null
                ? getLongestItemIndex(data)
                : refLongestItemIndex.current;
            var item = data[index];
            refLongestItemIndex.current = index;
            return item ? (react.createElement("div", { style: { height: 1, overflow: 'hidden', opacity: 0 } }, renderChild(item, index, { style: {} }))) : null;
        }
        return null;
    };
    return (react.createElement(resizeObserver/* default */.Z, { onResize: function () {
            if (refList.current && !(0,is/* isNumber */.hj)(styleListMaxHeight)) {
                var clientHeight = refList.current.clientHeight;
                setStateHeight(clientHeight);
            }
        } },
        react.createElement(WrapperTagName, VirtualList_assign({ ref: refList, style: VirtualList_assign(VirtualList_assign({ overflowY: 'auto', overflowAnchor: 'none' }, style), { maxHeight: styleListMaxHeight }), className: className, onScroll: isVirtual ? virtualListScrollHandler : rawListScrollHandler }, restProps), isVirtual ? (react.createElement(react.Fragment, null,
            react.createElement(VirtualList_Filler, { height: itemTotalHeight, outerStyle: outerStyle, innerStyle: innerStyle, offset: state.status === 'MEASURE_DONE' ? state.startItemTop : 0 }, renderChildren(data.slice(state.startIndex, state.endIndex + 1), state.startIndex)),
            renderLongestItem())) : needFiller ? (react.createElement(VirtualList_Filler, { height: viewportHeight, outerStyle: outerStyle, innerStyle: innerStyle }, renderChildren(data, 0))) : (renderChildren(data, 0)))));
});
VirtualList.displayName = 'VirtualList';
/* harmony default export */ var _class_VirtualList = (VirtualList);


/***/ }),

/***/ 25227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconHover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34855);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40360);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



function IconHover(props) {
    var _a;
    var children = props.children, className = props.className, disabled = props.disabled, prefix = props.prefix, _b = props.size, size = _b === void 0 ? 'default' : _b, rest = __rest(props, ["children", "className", "disabled", "prefix", "size"]);
    var getPrefixCls = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_1__/* .ConfigContext */ .E_).getPrefixCls;
    var prefixCls = getPrefixCls('icon-hover');
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", __assign({ className: (0,_util_classNames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prefixCls, (_a = {},
            _a[prefix + "-icon-hover"] = prefix,
            _a[prefixCls + "-size-" + size] = size && size !== 'default',
            _a[prefixCls + "-disabled"] = disabled,
            _a), className), onClick: props.onClick }, rest), children));
}


/***/ }),

/***/ 78033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _icon_react_icon_IconClose__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59547);
/* harmony import */ var _icon_react_icon_IconCheckCircleFill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19530);
/* harmony import */ var _icon_react_icon_IconCloseCircleFill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39911);
/* harmony import */ var _icon_react_icon_IconInfoCircleFill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65081);
/* harmony import */ var _icon_react_icon_IconExclamationCircleFill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67012);
/* harmony import */ var _icon_react_icon_IconLoading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69049);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34855);
/* harmony import */ var _class_icon_hover__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25227);
/* harmony import */ var _icon_react_icon_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4245);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var Notice = /** @class */ (function (_super) {
    __extends(Notice, _super);
    function Notice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startTimer = function () {
            var _a = _this.props, duration = _a.duration, onClose = _a.onClose, id = _a.id;
            // 自动关闭
            if (duration !== 0) {
                _this.timer = window.setTimeout(function () {
                    onClose && onClose(id);
                    _this.removeTimer();
                }, duration);
            }
        };
        _this.removeTimer = function () {
            if (_this.timer) {
                window.clearTimeout(_this.timer);
                _this.timer = null;
            }
        };
        _this.onClose = function () {
            _this.props.onClose && _this.props.onClose(_this.props.id);
        };
        _this.renderIcon = function () {
            var _a = _this.props, showIcon = _a.showIcon, icon = _a.icon, type = _a.type, prefixCls = _a.prefixCls, iconPrefix = _a.iconPrefix;
            var content;
            if (icon) {
                content = icon;
            }
            else if (showIcon) {
                switch (type) {
                    case 'info':
                        content = react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconInfoCircleFill__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null);
                        break;
                    case 'success':
                        content = react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconCheckCircleFill__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null);
                        break;
                    case 'error':
                        content = react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconCloseCircleFill__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null);
                        break;
                    case 'warning':
                        content = react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconExclamationCircleFill__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null);
                        break;
                    case 'loading':
                        content = react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconLoading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null);
                        break;
                    default:
                        break;
                }
                content = (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_context__WEBPACK_IMPORTED_MODULE_6__/* .IconContext.Provider */ .P.Provider, { value: iconPrefix ? { prefixCls: iconPrefix } : {} }, content));
            }
            return react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: prefixCls + "-icon" }, content);
        };
        _this.onMouseEnter = function () {
            _this.removeTimer();
        };
        _this.onMouseLeave = function () {
            // An update operation may be triggered after mouseEnter to start a new timer.
            // mouseEnter(clear) => clickBtn => update(new timer) => mouseLeave
            _this.removeTimer();
            _this.startTimer();
        };
        return _this;
    }
    Notice.prototype.componentDidMount = function () {
        this.startTimer();
    };
    Notice.prototype.componentDidUpdate = function (nextProps) {
        if (nextProps.duration !== this.props.duration || this.props.update) {
            this.removeTimer();
            this.startTimer();
        }
    };
    Notice.prototype.componentWillUnmount = function () {
        this.removeTimer();
    };
    Notice.prototype.render = function () {
        var _a;
        var _b = this.props, title = _b.title, content = _b.content, showIcon = _b.showIcon, className = _b.className, style = _b.style, type = _b.type, btn = _b.btn, icon = _b.icon, prefixCls = _b.prefixCls, closable = _b.closable, noticeType = _b.noticeType, iconPrefix = _b.iconPrefix, rtl = _b.rtl, closeIcon = _b.closeIcon;
        var classNames = (0,_util_classNames__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(prefixCls, prefixCls + "-" + type, (_a = {},
            _a[prefixCls + "-closable"] = closable,
            _a[prefixCls + "-rtl"] = rtl,
            _a), className);
        var _closable = 'closable' in this.props ? closable : true;
        var shouldRenderIcon = showIcon;
        if (type === 'normal' && !icon) {
            shouldRenderIcon = false;
        }
        if (noticeType === 'message') {
            _closable = closable;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { textAlign: 'center' }, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: classNames, style: style, role: "alert" },
                    shouldRenderIcon && this.renderIcon(),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: prefixCls + "-content" }, content),
                    _closable &&
                        (closeIcon !== undefined ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { onClick: this.onClose, className: prefixCls + "-close-btn" }, closeIcon)) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_class_icon_hover__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { prefix: prefixCls, className: prefixCls + "-close-btn", onClick: this.onClose },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconClose__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, null)))))));
        }
        if (noticeType === 'notification') {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: classNames, style: style, role: "alert" },
                    shouldRenderIcon && react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-left" }, this.renderIcon()),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-right" },
                        title && react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-title" }, title),
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-content" }, content),
                        btn && react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-btn-wrapper" }, btn)),
                    _closable &&
                        (closeIcon !== undefined ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { onClick: this.onClose, className: prefixCls + "-close-btn" }, closeIcon)) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_class_icon_hover__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { prefix: prefixCls, className: prefixCls + "-close-btn", onClick: this.onClose },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_context__WEBPACK_IMPORTED_MODULE_6__/* .IconContext.Provider */ .P.Provider, { value: iconPrefix ? { prefixCls: iconPrefix } : {} },
                                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconClose__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, null))))))));
        }
    };
    Notice.defaultProps = {
        type: 'info',
        showIcon: true,
        noticeType: 'message',
        duration: 3000,
    };
    return Notice;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));
/* harmony default export */ __webpack_exports__["Z"] = (Notice);


/***/ }),

/***/ 4272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/no-unused-state */

function getId(noticeProps) {
    if (noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.id) {
        return noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.id;
    }
    return "arco_notice_id_" + Math.random().toFixed(10).slice(2);
}
var BaseNotice = /** @class */ (function (_super) {
    __extends(BaseNotice, _super);
    function BaseNotice(props) {
        var _this = _super.call(this, props) || this;
        _this.add = function (noticeProps) {
            var id = getId(noticeProps);
            _this.setState(function (prevState) {
                var oldNotices = prevState.notices;
                // update notice
                if (noticeProps.id && ~oldNotices.findIndex(function (notice) { return notice.id === noticeProps.id; })) {
                    _this.update(noticeProps);
                    return prevState;
                }
                return {
                    notices: oldNotices.concat(__assign(__assign({}, noticeProps), { id: id })),
                    position: noticeProps.position,
                };
            });
            return id;
        };
        _this.update = function (newNotice) {
            var updatedNotices = _this.state.notices.map(function (oldNotice) {
                if (newNotice.id === oldNotice.id) {
                    newNotice.update = true;
                    return newNotice;
                }
                return oldNotice;
            });
            _this.setState({
                notices: updatedNotices,
            }, function () {
                var notices = _this.state.notices.map(function (oldNotice) {
                    if (newNotice.id === oldNotice.id && oldNotice.update) {
                        delete oldNotice.update;
                    }
                    return oldNotice;
                });
                _this.setState({ notices: notices });
            });
        };
        _this.clear = function () {
            _this.setState({
                notices: [],
            });
        };
        _this.state = {
            notices: [],
            position: 'topRight',
        };
        _this.remove = _this.remove.bind(_this);
        return _this;
    }
    BaseNotice.prototype.remove = function (id) {
        var newNotices = this.state.notices.filter(function (notice) { return notice.id !== id; });
        this.setState({
            notices: newNotices,
        });
    };
    return BaseNotice;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));
/* harmony default export */ __webpack_exports__["Z"] = (BaseNotice);


/***/ }),

/***/ 69404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ select_view; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pick.js
var pick = __webpack_require__(9472);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 3 modules
var ConfigProvider = __webpack_require__(40360);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDown/index.js
var IconDown = __webpack_require__(31944);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconClose/index.js
var IconClose = __webpack_require__(59547);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconSearch/index.js
var IconSearch = __webpack_require__(22208);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/InputTag/index.js + 1 modules
var InputTag = __webpack_require__(81682);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/input-element.js
var input_element = __webpack_require__(17538);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/include.js
// return an object with specify keys
function include(obj, keys) {
    var clone = {};
    Object.keys(obj).forEach(function (key) {
        if (keys.indexOf(key) !== -1) {
            clone[key] = obj[key];
        }
    });
    return clone;
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useForceUpdate.js
var useForceUpdate = __webpack_require__(65166);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/icon-hover.js
var icon_hover = __webpack_require__(25227);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/fillNBSP.js
var fillNBSP = __webpack_require__(97931);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/select-view.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
















var SearchStatus = {
    BEFORE: 0,
    EDITING: 1,
    NONE: 2,
};
var MAX_TAG_COUNT_VALUE_PLACEHOLDER = '__arco_value_tag_placeholder';
var CoreSelectView = react.forwardRef(function (props, ref) {
    var _a, _b;
    var id = props.id, style = props.style, className = props.className, size = props.size, bordered = props.bordered, allowClear = props.allowClear, allowCreate = props.allowCreate, status = props.status, loading = props.loading, disabled = props.disabled, animation = props.animation, prefixCls = props.prefixCls, suffixIcon = props.suffixIcon, arrowIcon = props.arrowIcon, removeIcon = props.removeIcon, clearIcon = props.clearIcon, placeholder = props.placeholder, renderText = props.renderText, value = props.value, inputValue = props.inputValue, popupVisible = props.popupVisible, maxTagCount = props.maxTagCount, isMultiple = props.isMultiple, isEmptyValue = props.isEmptyValue, prefix = props.prefix, ariaControls = props.ariaControls, renderTag = props.renderTag, dragToSort = props.dragToSort, rtl = props.rtl, htmlDataAttributes = props.htmlDataAttributes, onKeyDown = props.onKeyDown, onChangeInputValue = props.onChangeInputValue, onPaste = props.onPaste, onClear = props.onClear, onFocus = props.onFocus, onBlur = props.onBlur, onRemoveCheckedItem = props.onRemoveCheckedItem, onSort = props.onSort, rest = __rest(props, ["id", "style", "className", "size", "bordered", "allowClear", "allowCreate", "status", "loading", "disabled", "animation", "prefixCls", "suffixIcon", "arrowIcon", "removeIcon", "clearIcon", "placeholder", "renderText", "value", "inputValue", "popupVisible", "maxTagCount", "isMultiple", "isEmptyValue", "prefix", "ariaControls", "renderTag", "dragToSort", "rtl", "htmlDataAttributes", "onKeyDown", "onChangeInputValue", "onPaste", "onClear", "onFocus", "onBlur", "onRemoveCheckedItem", "onSort"]);
    // refs
    var refInput = (0,react.useRef)(null);
    var refWrapper = (0,react.useRef)(null);
    // state
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), ctxSize = _c.size, getPrefixCls = _c.getPrefixCls;
    var _d = __read((0,react.useState)(SearchStatus.NONE), 2), searchStatus = _d[0], setSearchStatus = _d[1];
    var _e = __read((0,react.useState)(false), 2), focused = _e[0], setFocused = _e[1];
    var forceUpdate = (0,useForceUpdate/* default */.Z)();
    // TODO：Will the search be completely controlled by showSearch? Next major version needs to be considered
    var showSearch = 'showSearch' in props ? props.showSearch : isMultiple;
    var canFocusInput = showSearch || allowCreate;
    var mergedSize = size || ctxSize;
    var mergedFocused = focused || popupVisible;
    var isRetainInputValueSearch = (0,is/* isObject */.Kn)(showSearch) && showSearch.retainInputValue;
    // the formatted text of value.
    var renderedValue = !isMultiple && value !== undefined ? renderText(value).text : '';
    // Avoid losing focus caused by clicking certain icons
    var keepFocus = function (event) {
        event && event.preventDefault();
    };
    var handleFocus = function (action) {
        var element = canFocusInput ? refInput.current : refWrapper.current;
        if (element) {
            action === 'focus' ? element.focus() : element.blur();
        }
    };
    var tryTriggerFocusChange = function (action, event) {
        // The focus event at this time should be triggered by the input element
        if (canFocusInput && event.target === refWrapper.current) {
            return;
        }
        if (action === 'focus') {
            setFocused(true);
            onFocus && onFocus(event);
        }
        else {
            setFocused(false);
            onBlur && onBlur(event);
        }
    };
    var tryTriggerKeyDown = function (event) {
        // The keyboard event at this time should be triggered by the input element, ignoring the bubbling up keyboard event
        if (canFocusInput && event.currentTarget === refWrapper.current) {
            return;
        }
        // Prevent the default behavior of the browser when pressing Enter, to avoid submit event in <form>
        var keyCode = event.keyCode || event.which;
        if (keyCode === keycode/* Enter.code */.Ce.code) {
            event.preventDefault();
        }
        onKeyDown && onKeyDown(event);
    };
    (0,react.useEffect)(function () {
        handleFocus(popupVisible ? 'focus' : 'blur');
        if (canFocusInput) {
            setSearchStatus(popupVisible ? SearchStatus.BEFORE : SearchStatus.NONE);
        }
    }, [popupVisible]);
    (0,react.useImperativeHandle)(ref, function () { return ({
        dom: refWrapper.current,
        focus: handleFocus.bind(null, 'focus'),
        blur: handleFocus.bind(null, 'blur'),
        getWidth: function () { return refWrapper.current && refWrapper.current.clientWidth; },
    }); });
    var mergedArrowIcon = 'arrowIcon' in props ? (arrowIcon === null ? null : (react.createElement("div", { className: prefixCls + "-arrow-icon" }, arrowIcon))) : (react.createElement("div", { className: prefixCls + "-arrow-icon" },
        react.createElement(IconDown/* default */.Z, null)));
    var mergedSuffixIcon = loading ? (react.createElement("span", { className: prefixCls + "-loading-icon" },
        react.createElement(IconLoading/* default */.Z, null))) : suffixIcon ? (react.createElement("span", { className: prefixCls + "-suffix-icon" }, suffixIcon)) : props.showSearch && popupVisible ? (react.createElement("div", { className: prefixCls + "-search-icon" },
        react.createElement(IconSearch/* default */.Z, null))) : (mergedArrowIcon);
    // event handling of input box
    var inputEventHandlers = {
        paste: onPaste,
        keyDown: tryTriggerKeyDown,
        focus: function (event) {
            event.stopPropagation();
            tryTriggerFocusChange('focus', event);
        },
        blur: function (event) {
            event.stopPropagation();
            tryTriggerFocusChange('blur', event);
        },
        change: function (newValue, event) {
            setSearchStatus(SearchStatus.EDITING);
            onChangeInputValue && onChangeInputValue(newValue, event);
        },
    };
    var renderSingle = function () {
        var _a;
        var _inputValue;
        switch (searchStatus) {
            case SearchStatus.BEFORE:
                _inputValue = inputValue || (isRetainInputValueSearch ? renderedValue : '');
                break;
            case SearchStatus.EDITING:
                _inputValue = inputValue || '';
                break;
            default:
                _inputValue = renderedValue;
                break;
        }
        // <input> is used to input and display placeholder, in other cases use <span> to display value to support displaying rich text
        var needShowInput = !!((mergedFocused && canFocusInput) || isEmptyValue);
        var inputProps = {
            style: { width: '100%' },
            // _inputValue after renderText(value) may be rich text, but the value of <input> cannot be object
            value: needShowInput && typeof _inputValue !== 'object' ? _inputValue : '',
            // Allow placeholder to display the selected value first when searching
            placeholder: canFocusInput && renderedValue && typeof renderedValue !== 'object'
                ? renderedValue
                : placeholder,
        };
        if (canFocusInput) {
            inputProps.onPaste = inputEventHandlers.paste;
            inputProps.onKeyDown = inputEventHandlers.keyDown;
            inputProps.onFocus = inputEventHandlers.focus;
            inputProps.onBlur = inputEventHandlers.blur;
            inputProps.onChange = inputEventHandlers.change;
        }
        else {
            // Avoid input getting focus by Tab
            // Do NOT pass [disabled] to <input>, otherwise the click event will not be triggered
            // https://stackoverflow.com/questions/7833854/jquery-detect-click-on-disabled-submit-button
            inputProps.tabIndex = -1;
            inputProps.style.pointerEvents = 'none';
        }
        return (react.createElement("span", { className: prefixCls + "-view-selector" },
            react.createElement(input_element/* default */.Z, __assign({ "aria-hidden": !needShowInput || undefined, ref: refInput, disabled: disabled, className: (0,classNames/* default */.Z)(prefixCls + "-view-input", (_a = {},
                    _a[prefixCls + "-hidden"] = !needShowInput,
                    _a)), autoComplete: "off" }, inputProps)),
            needShowInput ? (react.createElement("span", { className: prefixCls + "-view-value-mirror" }, (0,fillNBSP/* default */.Z)(inputProps.value ? _inputValue : inputProps.placeholder))) : null,
            react.createElement("span", { style: needShowInput ? { display: 'none' } : {}, className: prefixCls + "-view-value" }, (0,fillNBSP/* default */.Z)(isEmptyValue ? inputProps.placeholder : _inputValue))));
    };
    var renderMultiple = function () {
        var usedValue = (0,is/* isUndefined */.o8)(value) ? [] : [].concat(value);
        var maxTagCountNumber = (0,is/* isObject */.Kn)(maxTagCount) ? maxTagCount.count : maxTagCount;
        var maxTagCountRender = (0,is/* isObject */.Kn)(maxTagCount) && (0,is/* isFunction */.mf)(maxTagCount.render)
            ? maxTagCount.render
            : function (invisibleCount) { return "+" + invisibleCount + "..."; };
        var usedMaxTagCount = typeof maxTagCountNumber === 'number' ? Math.max(maxTagCountNumber, 0) : usedValue.length;
        var tagsToShow = [];
        var lastClosableTagIndex = -1;
        for (var i = usedValue.length - 1; i >= 0; i--) {
            var v = usedValue[i];
            var result = renderText(v);
            if (i < usedMaxTagCount) {
                tagsToShow.unshift({
                    value: v,
                    label: result.text,
                    closable: !result.disabled,
                });
            }
            if (!result.disabled && lastClosableTagIndex === -1) {
                lastClosableTagIndex = i;
            }
        }
        var invisibleTagCount = usedValue.length - usedMaxTagCount;
        if (invisibleTagCount > 0) {
            tagsToShow.push({
                label: maxTagCountRender(invisibleTagCount),
                closable: false,
                // InputTag needs to extract value as key
                value: MAX_TAG_COUNT_VALUE_PLACEHOLDER,
            });
        }
        var eventHandlers = {
            onPaste: inputEventHandlers.paste,
            onKeyDown: inputEventHandlers.keyDown,
            onFocus: inputEventHandlers.focus,
            onBlur: inputEventHandlers.blur,
            onInputChange: inputEventHandlers.change,
            onRemove: function (value, index, event) {
                // Should always delete the last option value when press Backspace
                var keyCode = event.keyCode || event.which;
                if (keyCode === keycode/* Backspace.code */.kW.code && lastClosableTagIndex > -1) {
                    value = usedValue[lastClosableTagIndex];
                    index = lastClosableTagIndex;
                }
                // If there is a limit on the maximum number of tags, the parameters passed into InputTag need to be recalculated
                maxTagCount && forceUpdate();
                onRemoveCheckedItem && onRemoveCheckedItem(value, index, event);
            },
        };
        // Avoid properties from configProvider affecting here
        var inputPropsOverrideConfigProvider = {
            suffix: null,
            prefix: null,
            addBefore: null,
            addAfter: null,
            allowClear: false,
            labelInValue: false,
        };
        return (react.createElement(InputTag/* default */.Z, __assign({}, inputPropsOverrideConfigProvider, { 
            // Avoid when clicking outside the browser window, InputTag out of focus
            className: mergedFocused ? getPrefixCls('input-tag') + "-focus" : '', ref: refInput, disabled: disabled, dragToSort: dragToSort, disableInput: !showSearch, animation: animation, placeholder: placeholder, value: tagsToShow, inputValue: inputValue, size: mergedSize, tagClassName: prefixCls + "-tag", renderTag: renderTag, icon: { removeIcon: removeIcon }, onChange: function (newValue, reason) {
                if (onSort && reason === 'sort') {
                    var indexOfMaxTagCount = newValue.indexOf(MAX_TAG_COUNT_VALUE_PLACEHOLDER);
                    // inject the invisible values tags to middle after dragging the "+x" tag
                    if (indexOfMaxTagCount > -1) {
                        var headArr = newValue.slice(0, indexOfMaxTagCount);
                        var tailArr = newValue.slice(indexOfMaxTagCount + 1);
                        var midArr = usedValue.slice(-invisibleTagCount);
                        onSort(headArr.concat(midArr, tailArr));
                    }
                    else {
                        onSort(newValue);
                    }
                }
            } }, eventHandlers)));
    };
    var selectStatus = status || (props.error ? 'error' : undefined);
    var mergedClearIcon = !disabled && !isEmptyValue && allowClear ? (react.createElement(icon_hover/* default */.Z, { size: mergedSize, key: "clearIcon", className: prefixCls + "-clear-icon", onClick: onClear, onMouseDown: keepFocus }, clearIcon !== undefined && clearIcon !== null ? clearIcon : react.createElement(IconClose/* default */.Z, null))) : null;
    var classNameStr = (0,classNames/* default */.Z)(prefixCls, prefixCls + "-" + (isMultiple ? 'multiple' : 'single'), (_a = {},
        _a[prefixCls + "-show-search"] = showSearch,
        _a[prefixCls + "-open"] = popupVisible,
        _a[prefixCls + "-size-" + mergedSize] = mergedSize,
        _a[prefixCls + "-focused"] = mergedFocused,
        _a[prefixCls + "-" + selectStatus] = selectStatus,
        _a[prefixCls + "-disabled"] = disabled,
        _a[prefixCls + "-no-border"] = !bordered,
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    return (react.createElement("div", __assign({ role: "combobox", "aria-haspopup": "listbox", "aria-autocomplete": "list", "aria-expanded": popupVisible, "aria-disabled": disabled, "aria-controls": ariaControls }, include(rest, ['onClick', 'onMouseEnter', 'onMouseLeave']), htmlDataAttributes, { ref: refWrapper, tabIndex: disabled ? -1 : 0, id: id, style: style, className: classNameStr, 
        // When there is an input box, the keyboard events are handled inside the input box to avoid triggering redundant events in the Chinese input method
        onKeyDown: tryTriggerKeyDown, onFocus: function (event) {
            if (!disabled && !dragToSort) {
                // Focus on the input, otherwise you need to press the Tab key twice to focus on the input box
                if (canFocusInput) {
                    refInput.current && refInput.current.focus();
                }
                else {
                    tryTriggerFocusChange('focus', event);
                }
            }
        }, onBlur: function (event) { return tryTriggerFocusChange('blur', event); } }),
        react.createElement("div", { title: typeof renderedValue === 'string' ? renderedValue : undefined, className: (0,classNames/* default */.Z)(prefixCls + "-view", (_b = {},
                _b[prefixCls + "-view-with-prefix"] = prefix,
                _b)), onClick: function (e) { return popupVisible && canFocusInput && e.stopPropagation(); } },
            prefix && (react.createElement("div", { "aria-hidden": "true", className: (0,classNames/* default */.Z)(prefixCls + "-prefix"), onMouseDown: function (event) { return focused && keepFocus(event); } }, prefix)),
            isMultiple ? renderMultiple() : renderSingle(),
            react.createElement("div", { "aria-hidden": "true", className: prefixCls + "-suffix", onMouseDown: function (event) { return focused && keepFocus(event); } },
                mergedClearIcon,
                mergedSuffixIcon))));
});
var SelectView = function (props, ref) {
    var _a;
    var prefixCls = props.prefixCls, id = props.id, style = props.style, className = props.className, addBefore = props.addBefore, rtl = props.rtl, renderView = props.renderView, propsAutoWidth = props.autoWidth, rest = __rest(props, ["prefixCls", "id", "style", "className", "addBefore", "rtl", "renderView", "autoWidth"]);
    var autoWidth = propsAutoWidth
        ? __assign({ minWidth: 0, maxWidth: '100%' }, ((0,is/* isObject */.Kn)(propsAutoWidth) ? propsAutoWidth : {})) : null;
    var refCoreSelectView = (0,react.useRef)(null);
    var needAddBefore = addBefore !== null && addBefore !== undefined;
    // const needAddAfter = addAfter !== null && addAfter !== undefined;
    var needAddAfter = false;
    var needWrapper = needAddBefore || needAddAfter;
    var propsAppliedToRoot = {
        id: id,
        style: __assign(__assign(__assign({}, autoWidth), { width: autoWidth ? 'auto' : undefined }), style),
        className: className,
    };
    var htmlDataAttributes = (0,pick/* pickDataAttributes */.m)(rest);
    (0,react.useImperativeHandle)(ref, function () { return refCoreSelectView.current; });
    var eleCoreSelectView = (react.createElement(CoreSelectView, __assign({}, props, { ref: refCoreSelectView, id: needWrapper ? undefined : propsAppliedToRoot.id, style: needWrapper ? undefined : propsAppliedToRoot.style, className: needWrapper ? undefined : propsAppliedToRoot.className, htmlDataAttributes: needWrapper ? {} : htmlDataAttributes })));
    if (typeof renderView === 'function') {
        eleCoreSelectView = renderView(eleCoreSelectView);
    }
    if (!needWrapper) {
        return eleCoreSelectView;
    }
    return (react.createElement("div", __assign({}, htmlDataAttributes, propsAppliedToRoot, { className: (0,classNames/* default */.Z)(prefixCls + "-wrapper", (_a = {},
            _a[prefixCls + "-wrapper-rtl"] = rtl,
            _a), propsAppliedToRoot.className) }),
        needAddBefore && react.createElement("div", { className: prefixCls + "-addbefore" }, addBefore),
        eleCoreSelectView));
};
var SelectViewComponent = react.forwardRef(SelectView);
SelectViewComponent.displayName = 'SelectView';
/* harmony default export */ var select_view = (SelectViewComponent);


/***/ }),

/***/ 34855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53367);
/* harmony import */ var _warning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97802);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var length = args.length;
    var classNames = [];
    var _loop_1 = function (i) {
        var v = args[i];
        if (!v) {
            return "continue";
        }
        if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v)) {
            classNames.push(v);
        }
        else if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .kJ)(v)) {
            classNames = classNames.concat(v);
        }
        else if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(v)) {
            Object.keys(v).forEach(function (k) {
                if (v[k]) {
                    classNames.push(k);
                }
            });
        }
        else {
            (0,_warning__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(true, 'arguments must be one of string/array/object.');
        }
    };
    for (var i = 0; i < length; i++) {
        _loop_1(i);
    }
    return __spreadArray([], __read(new Set(classNames)), false).join(' ');
}


/***/ }),

/***/ 91702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ newArray; },
/* harmony export */   "Yy": function() { return /* binding */ pickTriggerPropsFromRest; },
/* harmony export */   "dG": function() { return /* binding */ NOOP; }
/* harmony export */ });
/* harmony import */ var _pick__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9472);

var NOOP = function () { };
function newArray(length) {
    return Array.apply(null, Array(length));
}
function pickTriggerPropsFromRest(rest) {
    return (0,_pick__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(rest, [
        'onMouseEnter',
        'onMouseLeave',
        'onMouseMove',
        'onContextMenu',
        'onClick',
        'onFocus',
        'onBlur',
        'tabIndex',
    ]);
}


/***/ }),

/***/ 996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40360);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


var ContextHolderElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_props, ref) {
    var configContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_1__/* .ConfigContext */ .E_);
    var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), 2), instances = _a[0], setInstances = _a[1];
    function addInstance(ins) {
        setInstances(function (originInstances) { return __spreadArray(__spreadArray([], __read(originInstances), false), [ins], false); });
    }
    function removeInstance(ins) {
        setInstances(function (originInstances) { return originInstances.filter(function (originIns) { return ins !== originIns; }); });
    }
    function getContextConfig() {
        return configContext;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () { return ({
        addInstance: addInstance,
        removeInstance: removeInstance,
        getContextConfig: getContextConfig,
    }); });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(instances, function (child, index) { return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, { key: index }); })));
});
/* harmony default export */ __webpack_exports__["Z"] = (ContextHolderElement);


/***/ }),

/***/ 53412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ET": function() { return /* binding */ isServerRendering; },
/* harmony export */   "IF": function() { return /* binding */ getScrollElements; },
/* harmony export */   "Ib": function() { return /* binding */ isScrollElement; },
/* harmony export */   "S1": function() { return /* binding */ off; },
/* harmony export */   "on": function() { return /* binding */ on; },
/* harmony export */   "r3": function() { return /* binding */ contains; }
/* harmony export */ });
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91702);

var isServerRendering = (function () {
    try {
        return !(typeof window !== 'undefined' && document !== undefined);
    }
    catch (e) {
        return true;
    }
})();
var on = (function () {
    if (isServerRendering) {
        return _constant__WEBPACK_IMPORTED_MODULE_0__/* .NOOP */ .dG;
    }
    return function (element, event, handler, options) {
        element && element.addEventListener(event, handler, options || false);
    };
})();
var off = (function () {
    if (isServerRendering) {
        return _constant__WEBPACK_IMPORTED_MODULE_0__/* .NOOP */ .dG;
    }
    return function (element, event, handler, options) {
        element && element.removeEventListener(event, handler, options || false);
    };
})();
var contains = function (root, ele) {
    if (!root) {
        return false;
    }
    if (root.contains) {
        return root.contains(ele);
    }
    var node = ele;
    while (node) {
        if (node === root) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};
var isScrollElement = function (element) {
    var clientHeight = element === document.documentElement ? element.clientHeight : element.offsetHeight;
    var clientWidth = element === document.documentElement ? element.clientWidth : element.offsetWidth;
    return element.scrollHeight > clientHeight || element.scrollWidth > clientWidth;
};
/**
 * 从当前节点向上查找所有的滚动元素
 * @param container 当前节点
 * @param top 查找到 top 节点就终止，不再继续查找
 * @returns
 */
var getScrollElements = function (container, top) {
    if (top === void 0) { top = document.documentElement; }
    var scrollElements = [];
    var element = container;
    while (element && element !== top) {
        if (isScrollElement(element)) {
            scrollElements.push(element);
        }
        element = element.parentElement;
    }
    return scrollElements;
};


/***/ }),

/***/ 97931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
// Replace empty string to &nbsp;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(str) {
    return typeof str === 'string'
        ? str.replace(/(\s{2,})|(\s{1,}$)/g, function ($0) { return '\u00A0'.repeat($0.length); })
        : str;
}


/***/ }),

/***/ 993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getHighlightText; }
/* harmony export */ });
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3522);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53367);



function getHighlightText(_a) {
    var nodeList = _a.nodeList, pattern = _a.pattern, highlightClassName = _a.highlightClassName;
    if (!pattern) {
        return nodeList;
    }
    var transformNode = function (node) {
        if (node && node.props && typeof node.props.children === 'string') {
            return (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(node, undefined, react__WEBPACK_IMPORTED_MODULE_1__.createElement(HighlightText, { text: node.props.children, keyword: pattern, highlightClassName: highlightClassName }));
        }
        return node;
    };
    return (0,_is__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(nodeList) ? nodeList.map(function (node) { return transformNode(node); }) : transformNode(nodeList);
}
function HighlightText(_a) {
    var text = _a.text, keyword = _a.keyword, highlightClassName = _a.highlightClassName;
    if (!keyword)
        return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, text);
    // limit keyword length to avoid Regular expression too large error
    if (keyword.length > 1000) {
        keyword = keyword.slice(0, 1000);
    }
    // 注意这里的括号，这里使用了带capture group功能的正则，来split字符串
    // 从而在strArr中可以保留匹配文本
    var re = new RegExp("(" + lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_0___default()(keyword) + ")", 'i');
    var strArr = text.split(re);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, strArr.map(function (item, index) {
        return re.test(item) ? (react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", { key: index, className: highlightClassName }, item)) : (react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", { key: index }, item));
    })));
}


/***/ }),

/***/ 46970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getHotkeyHandler; }
/* harmony export */ });
var stringifyHotkey = function (k) {
    return JSON.stringify({
        code: k.code,
        ctrl: !!k.ctrl,
        shift: !!k.shift,
        alt: !!k.alt,
        meta: !!k.meta,
    });
};
/**
 * @param hotkeyMap - 快捷键描述对象
 */
function getHotkeyHandler(hotkeyMap) {
    var map = {};
    hotkeyMap.forEach(function (callback, hotkey) {
        hotkey = typeof hotkey === 'number' ? { code: hotkey } : hotkey;
        map[stringifyHotkey(hotkey)] = callback;
    });
    return function (event) {
        var key = stringifyHotkey({
            code: event.keyCode || event.which,
            ctrl: !!event.ctrlKey,
            shift: !!event.shiftKey,
            alt: !!event.altKey,
            meta: !!event.metaKey,
        });
        var callback = map[key];
        if (callback) {
            event.stopPropagation();
            if (callback(event) === false) {
                event.preventDefault();
            }
        }
    };
}


/***/ }),

/***/ 65166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForceUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

function useForceUpdate() {
    var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(function (v) { return v + 1; }, 0), 2), dispatch = _a[1];
    return dispatch;
}


/***/ }),

/***/ 74732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

var globalInstanceIdMap = {};
/**
 * Provide unique component name while using this hook
 * In react 18, React.useId is a better way to choose
 * Related issue: https://github.com/arco-design/arco-design/issues/958
 */
function useId(prefix) {
    var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), id = _a[0], setId = _a[1];
    // Update ID in next render to avoid SSR [prop dit not match] error
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        globalInstanceIdMap[prefix] = prefix in globalInstanceIdMap ? globalInstanceIdMap[prefix] : 0;
        setId(globalInstanceIdMap[prefix]);
        globalInstanceIdMap[prefix] += 1;
    }, []);
    return typeof id === 'number' ? "" + prefix + id : undefined;
}


/***/ }),

/***/ 91626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsFirstRender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useIsFirstRender() {
    var isFirst = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        isFirst.current = false;
    }, []);
    return isFirst.current;
}


/***/ }),

/***/ 81109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53412);


// Because useLayoutEffect in the ssr environment will report a warning
// So when you need to use useLayoutEffect, use useIsomorphicLayoutEffect instead, it will use useEffect in the ssr environment to avoid this problem
var useIsomorphicLayoutEffect = _dom__WEBPACK_IMPORTED_MODULE_1__/* .isServerRendering */ .ET ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 57483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _keycode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85660);


function useKeyboardEvent(props) {
    var getEventListeners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (callbacks) {
        return {
            onKeyDown: function (e) {
                var _a, _b, _c, _d, _e, _f;
                var keyCode = e.keyCode || e.which;
                if (keyCode === _keycode__WEBPACK_IMPORTED_MODULE_1__/* .Enter.code */ .Ce.code) {
                    (_a = callbacks.onPressEnter) === null || _a === void 0 ? void 0 : _a.call(callbacks, e);
                }
                if (keyCode === _keycode__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDown.code */ .K5.code) {
                    (_b = callbacks.onArrowDown) === null || _b === void 0 ? void 0 : _b.call(callbacks, e);
                }
                if (keyCode === _keycode__WEBPACK_IMPORTED_MODULE_1__/* .ArrowLeft.code */ .Xd.code) {
                    (_c = callbacks.onArrowLeft) === null || _c === void 0 ? void 0 : _c.call(callbacks, e);
                }
                if (keyCode === _keycode__WEBPACK_IMPORTED_MODULE_1__/* .ArrowRight.code */ .ol.code) {
                    (_d = callbacks.onArrowRight) === null || _d === void 0 ? void 0 : _d.call(callbacks, e);
                }
                if (keyCode === _keycode__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUp.code */ .a2.code) {
                    (_e = callbacks.onArrowUp) === null || _e === void 0 ? void 0 : _e.call(callbacks, e);
                }
                (_f = props === null || props === void 0 ? void 0 : props.onKeyDown) === null || _f === void 0 ? void 0 : _f.call(props, e);
            },
        };
    }, []);
    return getEventListeners;
}


/***/ }),

/***/ 92833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMergeProps; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50049);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


function useMergeProps(componentProps, defaultProps, globalComponentConfig) {
    var _ignorePropsFromGlobal = componentProps._ignorePropsFromGlobal;
    var _defaultProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        return __assign(__assign({}, defaultProps), (_ignorePropsFromGlobal ? {} : globalComponentConfig));
    }, [defaultProps, globalComponentConfig, _ignorePropsFromGlobal]);
    var props = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        // Must remove property of MergePropsOptions before passing it to component
        var mProps = (0,_omit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(componentProps, ['_ignorePropsFromGlobal']);
        // https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react/src/ReactElement.js#L312
        for (var propName in _defaultProps) {
            if (mProps[propName] === undefined) {
                mProps[propName] = _defaultProps[propName];
            }
        }
        return mProps;
    }, [componentProps, _defaultProps]);
    return props;
}


/***/ }),

/***/ 15955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMergeValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53367);
/* harmony import */ var _usePrevious__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69882);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};



function useMergeValue(defaultStateValue, props) {
    var _a = props || {}, defaultValue = _a.defaultValue, value = _a.value;
    var firstRenderRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    var prevPropsValue = (0,_usePrevious__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value);
    var _b = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!(0,_is__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(value) ? value : !(0,_is__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(defaultValue) ? defaultValue : defaultStateValue), 2), stateValue = _b[0], setStateValue = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // 第一次渲染时候，props.value 已经在useState里赋值给stateValue了，不需要再次赋值。
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        // 外部value等于undefined，也就是一开始有值，后来变成了undefined（
        // 可能是移除了value属性，或者直接传入的undefined），那么就更新下内部的值。
        // 如果value有值，在下一步逻辑中直接返回了value，不需要同步到stateValue
        /**
         *  prevPropsValue !== value: https://github.com/arco-design/arco-design/issues/1686
         *  react18 严格模式下 useEffect 执行两次，可能出现 defaultValue 不生效的问题。
         */
        if (value === undefined && prevPropsValue !== value) {
            setStateValue(value);
        }
    }, [value]);
    var mergedValue = (0,_is__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(value) ? stateValue : value;
    return [mergedValue, setStateValue, stateValue];
}


/***/ }),

/***/ 88271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOverflowHidden; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useOverflowHidden(getContainer, _a) {
    var hidden = _a.hidden;
    var needResetContainerStyle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var originContainerStyle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    var getScrollBarWidth = function (element) {
        return element.tagName === 'BODY'
            ? window.innerWidth - (document.body.clientWidth || document.documentElement.clientWidth)
            : element.offsetWidth - element.clientWidth;
    };
    var setContainerStyle = function () {
        var container = getContainer();
        if (container && container.style.overflow !== 'hidden') {
            var originStyle = container.style;
            needResetContainerStyle.current = true;
            // 记录并设置宽度
            var containerScrollBarWidth = getScrollBarWidth(container);
            if (containerScrollBarWidth) {
                originContainerStyle.current.width = originStyle.width;
                container.style.width = "calc(" + (container.style.width || '100%') + " - " + containerScrollBarWidth + "px)";
            }
            // 记录并设置overflow
            originContainerStyle.current.overflow = originStyle.overflow;
            container.style.overflow = 'hidden';
        }
    };
    var resetContainerStyle = function () {
        if (needResetContainerStyle.current && getContainer()) {
            var container_1 = getContainer();
            var originStyle_1 = originContainerStyle.current;
            Object.keys(originStyle_1).forEach(function (i) { return (container_1.style[i] = originStyle_1[i]); });
        }
        needResetContainerStyle.current = false;
        originContainerStyle.current = {};
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        hidden ? setContainerStyle() : resetContainerStyle();
        return function () {
            resetContainerStyle();
        };
    }, [getContainer, hidden]);
    return [resetContainerStyle, setContainerStyle];
}


/***/ }),

/***/ 69882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function usePrevious(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        ref.current = value;
    });
    return ref.current;
}


/***/ }),

/***/ 23259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

function useStateWithPromise(defaultVal) {
    var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        value: defaultVal,
        resolve: function (e) {
            // eslint-disable-next-line no-unused-expressions
            e;
        },
    }), 2), state = _a[0], setState = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        state.resolve(state.value);
    }, [state]);
    return [
        state.value,
        function (updater) {
            return new Promise(function (resolve) {
                setState(function (prevState) {
                    var nextVal = updater;
                    if (typeof updater === 'function') {
                        nextVal = updater(prevState.value);
                    }
                    return {
                        value: nextVal,
                        resolve: resolve,
                    };
                });
            });
        },
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useStateWithPromise);


/***/ }),

/***/ 1083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useUpdate(fn, deps) {
    if (deps === void 0) { deps = []; }
    var isDidMount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (isDidMount.current) {
            fn();
        }
        else {
            isDidMount.current = true;
        }
    }, deps);
}


/***/ }),

/***/ 53367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ft": function() { return /* binding */ isNull; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "U$": function() { return /* binding */ isEmptyReactNode; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "jn": function() { return /* binding */ isBoolean; },
/* harmony export */   "kJ": function() { return /* binding */ isArray; },
/* harmony export */   "le": function() { return /* binding */ isNullOrUndefined; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "o8": function() { return /* binding */ isUndefined; },
/* harmony export */   "qE": function() { return /* binding */ isDayjs; },
/* harmony export */   "zE": function() { return /* binding */ isFile; }
/* harmony export */ });
/* unused harmony exports isRegExp, isBlob, isColor, isEmptyObject, isExist, isWindow */
var opt = Object.prototype.toString;
function isArray(obj) {
    return opt.call(obj) === '[object Array]';
}
function isObject(obj) {
    return opt.call(obj) === '[object Object]';
}
function isString(obj) {
    return opt.call(obj) === '[object String]';
}
function isNumber(obj) {
    return opt.call(obj) === '[object Number]' && obj === obj; // eslint-disable-line
}
function isRegExp(obj) {
    return opt.call(obj) === '[object RegExp]';
}
function isFile(obj) {
    return opt.call(obj) === '[object File]';
}
function isBlob(obj) {
    return opt.call(obj) === '[object Blob]';
}
function isHex(color) {
    return /^#[a-fA-F0-9]{3}$|#[a-fA-F0-9]{6}$/.test(color);
}
function isRgb(color) {
    return /^rgb\((\s*\d+\s*,?){3}\)$/.test(color);
}
function isRgba(color) {
    return /^rgba\((\s*\d+\s*,\s*){3}\s*\d(\.\d+)?\s*\)$/.test(color);
}
function isColor(color) {
    return isHex(color) || isRgb(color) || isRgba(color);
}
function isUndefined(obj) {
    return obj === undefined;
}
function isNull(obj) {
    return obj === null;
}
function isNullOrUndefined(obj) {
    return obj === null || obj === undefined;
}
function isFunction(obj) {
    return typeof obj === 'function';
}
function isEmptyObject(obj) {
    return isObject(obj) && Object.keys(obj).length === 0;
}
function isEmptyReactNode(node) {
    return !node && (node === null || node === undefined || node === '' || node === false);
}
function isExist(obj) {
    return obj || obj === 0;
}
function isWindow(el) {
    return el === window;
}
function isDayjs(time) {
    // dayjs.isDayjs 在实际应用场景，比如多个版本的 dayjs 会失效
    return (isObject(time) &&
        (('$y' in time &&
            '$M' in time &&
            '$D' in time &&
            '$d' in time &&
            '$H' in time &&
            '$m' in time &&
            '$s' in time) ||
            time._isAMomentObject) // 兼容 moment 的验证
    );
}
function isBoolean(value) {
    return typeof value === 'boolean';
}


/***/ }),

/***/ 85660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ Esc; },
/* harmony export */   "Ce": function() { return /* binding */ Enter; },
/* harmony export */   "K5": function() { return /* binding */ ArrowDown; },
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "Xd": function() { return /* binding */ ArrowLeft; },
/* harmony export */   "a2": function() { return /* binding */ ArrowUp; },
/* harmony export */   "kW": function() { return /* binding */ Backspace; },
/* harmony export */   "ol": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* unused harmony export Space */
// keyboard keycode
var Enter = {
    key: 'Enter',
    code: 13,
};
var Esc = {
    key: 'Escape',
    code: 27,
};
var Backspace = {
    key: 'Backspace',
    code: 8,
};
var Tab = {
    key: 'Tab',
    code: 9,
};
var Space = {
    key: '',
    code: 32,
};
var ArrowUp = {
    key: 'ArrowUp',
    code: 38,
};
var ArrowDown = {
    key: 'ArrowDown',
    code: 40,
};
var ArrowLeft = {
    key: 'ArrowLeft',
    code: 37,
};
var ArrowRight = {
    key: 'ArrowRight',
    code: 39,
};


/***/ }),

/***/ 38779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergeProps; }
/* harmony export */ });
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function mergeProps(componentProps, defaultProps, globalComponentConfig) {
    var _defaultProps = __assign(__assign({}, defaultProps), globalComponentConfig);
    var props = __assign({}, componentProps);
    // https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react/src/ReactElement.js#L312
    for (var propName in _defaultProps) {
        if (props[propName] === undefined) {
            props[propName] = _defaultProps[propName];
        }
    }
    return props;
}


/***/ }),

/***/ 50049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ omit; }
/* harmony export */ });
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// delete keys from object
function omit(obj, keys // string 为了某些没有声明的属性被omit
) {
    var clone = __assign({}, obj);
    keys.forEach(function (key) {
        if (key in clone) {
            delete clone[key];
        }
    });
    return clone;
}


/***/ }),

/***/ 9472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pick; },
/* harmony export */   "m": function() { return /* binding */ pickDataAttributes; }
/* harmony export */ });
// pick item from object
function pick(obj, keys) {
    var clone = {};
    keys.forEach(function (key) {
        var k = key;
        if (key in obj) {
            clone[k] = obj[k];
        }
    });
    return clone;
}
function pickDataAttributes(obj) {
    var clone = {};
    obj &&
        Object.keys(obj).forEach(function (key) {
            var k = String(key);
            if (k.indexOf('data-') === 0) {
                clone[k] = obj[k];
            }
            if (k.indexOf('aria-') === 0) {
                clone[k] = obj[k];
            }
        });
    return clone;
}


/***/ }),

/***/ 44734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ caf; },
/* harmony export */   "W": function() { return /* binding */ raf; }
/* harmony export */ });
var target = typeof window === 'undefined' ? __webpack_require__.g : window;
var vendors = ['webkit', 'ms', 'moz', 'o'];
var raf = target.requestAnimationFrame; // eslint-disable-line
var caf = target.cancelAnimationFrame; // eslint-disable-line
if (!raf || !caf) {
    vendors.some(function (prefix) {
        raf = target[prefix + "RequestAnimationFrame"];
        caf = target[prefix + "CancelAnimationFrame"] || target[prefix + "CancelRequestAnimationFrame"];
        return raf && caf;
    });
    if (!raf || !caf) {
        var lastTime_1 = 0;
        raf = function (cb) {
            var currentTime = Date.now();
            var diff = Math.max(0, 16 - (currentTime - lastTime_1));
            var timer = setTimeout(function () {
                cb();
                lastTime_1 = currentTime + diff;
            }, diff);
            return timer;
        };
        caf = function (timer) {
            clearTimeout(timer);
        };
    }
}
raf = raf.bind(target);
caf = caf.bind(target);



/***/ }),

/***/ 99583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ render; }
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73935);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53367);
var _a;


var __SECRET_INTERNALS__ = '__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED';
var CopyReactDOM = react_dom__WEBPACK_IMPORTED_MODULE_0__;
var copyRender;
var isReact18 = Number((_a = CopyReactDOM.version) === null || _a === void 0 ? void 0 : _a.split('.')[0]) > 17;
var updateUsingClientEntryPoint = function (skipWarning) {
    // https://github.com/facebook/react/blob/17806594cc28284fe195f918e8d77de3516848ec/packages/react-dom/npm/client.js#L10
    // Avoid console warning
    if ((0,_is__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn)(CopyReactDOM[__SECRET_INTERNALS__])) {
        CopyReactDOM[__SECRET_INTERNALS__].usingClientEntryPoint = skipWarning;
    }
};
var createRoot;
try {
    createRoot = CopyReactDOM.createRoot;
}
catch (_) {
    //
}
if (isReact18 && createRoot) {
    copyRender = function (app, container) {
        updateUsingClientEntryPoint(true);
        var root = createRoot(container);
        updateUsingClientEntryPoint(false);
        root.render(app);
        root._unmount = function () {
            setTimeout(function () {
                var _a;
                (_a = root === null || root === void 0 ? void 0 : root.unmount) === null || _a === void 0 ? void 0 : _a.call(root);
            });
        };
        return root;
    };
}
else {
    copyRender = function (app, container) {
        CopyReactDOM.render(app, container);
        return {
            render: function (app) {
                CopyReactDOM.render(app, container);
            },
            _unmount: function () {
                CopyReactDOM.unmountComponentAtNode(container);
            },
        };
    };
}
var render = copyRender;


/***/ }),

/***/ 68761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91033);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73935);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ResizeObserverComponent = /** @class */ (function (_super) {
    __extends(ResizeObserverComponent, _super);
    function ResizeObserverComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentWillUnmount = function () {
            if (_this.resizeObserver) {
                _this.destroyResizeObserver();
            }
        };
        _this.createResizeObserver = function () {
            var _a = _this.props.throttle, throttle = _a === void 0 ? true : _a;
            var onResize = function (entry) {
                var _a, _b;
                (_b = (_a = _this.props).onResize) === null || _b === void 0 ? void 0 : _b.call(_a, entry);
            };
            var resizeHandler = throttle ? lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(onResize) : onResize;
            var firstExec = true; // 首次监听时，立即执行一次 onResize，之前行为保持一致，避免布局类组件出现闪动的情况
            _this.resizeObserver = new resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(function (entry) {
                if (firstExec) {
                    firstExec = false;
                    onResize(entry);
                }
                resizeHandler(entry);
            });
            _this.resizeObserver.observe((0,react_dom__WEBPACK_IMPORTED_MODULE_3__.findDOMNode)(_this));
        };
        _this.destroyResizeObserver = function () {
            _this.resizeObserver && _this.resizeObserver.disconnect();
            _this.resizeObserver = null;
        };
        return _this;
    }
    ResizeObserverComponent.prototype.componentDidMount = function () {
        if (!react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(this.props.children)) {
            console.warn('The children of ResizeObserver is invalid.');
        }
        else {
            this.createResizeObserver();
        }
    };
    ResizeObserverComponent.prototype.componentDidUpdate = function () {
        if (!this.resizeObserver && (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.findDOMNode)(this)) {
            this.createResizeObserver();
        }
    };
    ResizeObserverComponent.prototype.render = function () {
        return this.props.children;
    };
    return ResizeObserverComponent;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));
/* harmony default export */ __webpack_exports__["Z"] = (ResizeObserverComponent);


/***/ }),

/***/ 40694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _raf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44734);
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(cb) {
    var timer = null;
    var throttle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        timer && (0,_raf__WEBPACK_IMPORTED_MODULE_0__/* .caf */ .N)(timer);
        timer = (0,_raf__WEBPACK_IMPORTED_MODULE_0__/* .raf */ .W)(function () {
            cb.apply(void 0, __spreadArray([], __read(args), false));
            timer = null;
        });
    };
    throttle.cancel = function () {
        (0,_raf__WEBPACK_IMPORTED_MODULE_0__/* .caf */ .N)(timer);
        timer = null;
    };
    return throttle;
}


/***/ }),

/***/ 97802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ warning; }
/* harmony export */ });
function warning(condition, message) {
    if (false) {}
}


/***/ }),

/***/ 64107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ locale_default; }
});

// EXTERNAL MODULE: ./node_modules/dayjs/locale/zh-cn.js
var zh_cn = __webpack_require__(33852);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/locale/zh-CN.js

var Calendar = {
    formatYear: 'YYYY 年',
    formatMonth: 'YYYY 年 MM 月',
    // 月份在前
    monthBeforeYear: false,
    today: '今天',
    view: {
        month: '月',
        year: '年',
        week: '周',
        day: '日',
    },
    month: {
        long: {
            January: '一月',
            February: '二月',
            March: '三月',
            April: '四月',
            May: '五月',
            June: '六月',
            July: '七月',
            August: '八月',
            September: '九月',
            October: '十月',
            November: '十一月',
            December: '十二月',
        },
        short: {
            January: '一月',
            February: '二月',
            March: '三月',
            April: '四月',
            May: '五月',
            June: '六月',
            July: '七月',
            August: '八月',
            September: '九月',
            October: '十月',
            November: '十一月',
            December: '十二月',
        },
    },
    week: {
        long: {
            self: '周',
            monday: '周一',
            tuesday: '周二',
            wednesday: '周三',
            thursday: '周四',
            friday: '周五',
            saturday: '周六',
            sunday: '周日',
        },
        short: {
            self: '周',
            monday: '一',
            tuesday: '二',
            wednesday: '三',
            thursday: '四',
            friday: '五',
            saturday: '六',
            sunday: '日',
        },
    },
};
/* harmony default export */ var zh_CN = ({
    locale: 'zh-CN',
    dayjsLocale: 'zh-cn',
    Calendar: Calendar,
    DatePicker: {
        Calendar: Calendar,
        placeholder: {
            date: '请选择日期',
            week: '请选择周',
            month: '请选择月份',
            year: '请选择年份',
            quarter: '请选择季度',
        },
        placeholders: {
            date: ['开始日期', '结束日期'],
            week: ['开始周', '结束周'],
            month: ['开始月份', '结束月份'],
            year: ['开始年份', '结束年份'],
            quarter: ['开始季度', '结束季度'],
        },
        selectTime: '选择时间',
        selectDate: '选择日期',
        today: '今天',
        now: '此刻',
        ok: '确定',
    },
    Drawer: {
        okText: '确定',
        cancelText: '取消',
    },
    Empty: {
        noData: '暂无数据',
    },
    Modal: {
        okText: '确定',
        cancelText: '取消',
    },
    Pagination: {
        goto: '前往',
        page: '页',
        countPerPage: '条/页',
        total: '共 {0} 条',
        prev: '上一页',
        next: '下一页',
        currentPage: '第 {0} 页',
        prevSomePages: '向前 {0} 页',
        nextSomePages: '向后 {0} 页',
        pageSize: '页码',
    },
    Popconfirm: {
        okText: '确定',
        cancelText: '取消',
    },
    Table: {
        okText: '确定',
        resetText: '重置',
        sortAscend: '点击升序',
        sortDescend: '点击降序',
        cancelSort: '取消排序',
    },
    TimePicker: {
        ok: '确定',
        placeholder: '请选择时间',
        placeholders: ['开始时间', '结束时间'],
        now: '此刻',
    },
    Progress: {
        success: '完成',
        error: '失败',
    },
    Upload: {
        start: '开始',
        cancel: '取消',
        delete: '删除',
        reupload: '点击重试',
        upload: '点击上传',
        preview: '预览',
        drag: '点击或拖拽文件到此处上传',
        dragHover: '释放文件并开始上传',
        error: '上传失败',
    },
    Typography: {
        copy: '复制',
        copied: '已复制',
        edit: '编辑',
        fold: '折叠',
        unfold: '展开',
    },
    Transfer: {
        resetText: '重置',
    },
    ImagePreview: {
        fullScreen: '全屏',
        rotateRight: '向右旋转',
        rotateLeft: '向左旋转',
        zoomIn: '放大',
        zoomOut: '缩小',
        originalSize: '原始尺寸',
    },
    Form: {
        validateMessages: {
            required: '#{field} 是必填项',
            type: {
                string: '#{field} 不是合法的文本类型',
                number: '#{field} 不是合法的数字类型',
                boolean: '#{field} 不是合法的布尔类型',
                array: '#{field} 不是合法的数组类型',
                object: '#{field} 不是合法的对象类型',
                url: '#{field} 不是合法的 url 地址',
                email: '#{field} 不是合法的邮箱地址',
                ip: '#{field} 不是合法的 IP 地址',
            },
            number: {
                min: '`#{value}` 小于最小值 `#{min}`',
                max: '`#{value}` 大于最大值 `#{max}`',
                equal: '`#{value}` 不等于 `#{equal}`',
                range: '`#{value}` 不在 `#{min} ~ #{max}` 范围内',
                positive: '`#{value}` 不是正数',
                negative: '`#{value}` 不是负数',
            },
            array: {
                length: '`#{field}` 个数不等于 #{length}',
                minLength: '`#{field}` 个数最少为 #{minLength}',
                maxLength: '`#{field}` 个数最多为 #{maxLength}',
                includes: '#{field} 不包含 #{includes}',
                deepEqual: '#{field} 不等于 #{deepEqual}',
                empty: '`#{field}` 不是空数组',
            },
            string: {
                minLength: '字符数最少为 #{minLength}',
                maxLength: '字符数最多为 #{maxLength}',
                length: '字符数必须是 #{length}',
                match: '`#{value}` 不符合模式 #{pattern}',
                uppercase: '`#{value}` 必须全大写',
                lowercase: '`#{value}` 必须全小写',
            },
            object: {
                deepEqual: '`#{field}` 不等于期望值',
                hasKeys: '`#{field}` 不包含必须字段',
                empty: '`#{field}` 不是对象',
            },
            boolean: {
                true: '期望是 `true`',
                false: '期望是 `false`',
            },
        },
    },
});

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/locale/default.js

/* harmony default export */ var locale_default = (zh_CN);


/***/ })

}]);